<app-table
  [actionColumnWidth]="300"
  [columns]="columns"
  [loading]="loading"
  [value]="statisticsCodes"
  filename="MENU.STATISTICS_CODES">
  @if (isManager()) {
    <ng-template
      (onClick)="createNewStatisticsCode()"
      appToolbarButton
      icon="fal fa-plus"
      labelKey="STATISTICS_CODES.CREATE_TITLE"></ng-template>
  }
  @if (isManager()) {
    <ng-template
      (onClick)="deleteStatisticsCode($event.row)"
      appActionButton
      displayIf="deletable"
      icon="fal fa-trash"
      labelKey="ACTIONS.DELETE"
      type="danger"></ng-template>
  }
</app-table>
